module.exports = __webpack_public_path__ + "static/media/Clayton P Hotson.10a379ca.png";